import { Brush, Camera, Palette, ShieldCheck, UserRound } from "lucide-react";
import type { PersonaOption } from "@/lib/authv2/store";

/**
 * Biểu tượng của một danh phận trong menu và hộp gán (bản mẫu v2).
 *
 * Là MỘT thành phần trả biểu tượng cố định, không phải hàm trả về thành phần:
 * gọi hàm lấy thành phần rồi vẽ ngay trong lúc render là React coi như thành
 * phần mới mỗi lần vẽ (trình soát `static-components` chặn).
 */
export function PersonaIcon({
  role,
  department,
  className,
}: Pick<PersonaOption, "role" | "department"> & { className?: string }) {
  const r = role.toLowerCase();
  const d = department.toLowerCase();
  if (r === "qc") return <ShieldCheck className={className} aria-hidden />;
  if (d.startsWith("photo")) return <Camera className={className} aria-hidden />;
  if (d === "makeup") return <Palette className={className} aria-hidden />;
  if (d === "retouch") return <Brush className={className} aria-hidden />;
  return <UserRound className={className} aria-hidden />;
}

/**
 * Biểu tượng trong ô vuông bo góc có nền màu — khối "Dùng với tư cách" (bản mẫu
 * v2): danh phận kiểm soát chất lượng tông nâu của thương hiệu, danh phận nghề
 * tông xanh của dải "Đang dùng với tư cách".
 */
export function PersonaIconBadge({ role, department }: Pick<PersonaOption, "role" | "department">) {
  const qc = role.toLowerCase() === "qc";
  return (
    <span
      aria-hidden
      className="grid h-8 w-8 shrink-0 place-items-center rounded-lg"
      style={
        qc
          ? { background: "var(--color-brand-glow)", color: "var(--color-brand)" }
          : { background: "var(--color-info-bg)", color: "var(--color-info-text)" }
      }
    >
      <PersonaIcon role={role} department={department} className="h-4 w-4" />
    </span>
  );
}
